// extracted by mini-css-extract-plugin
export var target = "target-module--target--0e601";
export var target__col = "target-module--target__col--17e5d";
export var target__item = "target-module--target__item--2e0c9";
export var target__itemBody = "target-module--target__item-body--d367d";
export var target__itemHead = "target-module--target__item-head--69e41";
export var target__itemHead1 = "target-module--target__item-head--1--0f538";
export var target__itemHead2 = "target-module--target__item-head--2--d041e";
export var target__itemText = "target-module--target__item--text--f99b6";